<template>
  <div class="modal-mask" v-on:keyup.esc="close" v-if="showModal">
    <div :id="props.id" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button 
              type="button" 
              class="close" 
              @click="close"
              >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              <slot name="props.title">
                {{ title }}
              </slot>
            </h4>
          </div>
          <div class="modal-body">
              <slot name="body"></slot>
          </div>
          <div class="modal-footer">
              <slot name="footer"></slot>
              <button class="btn btn-default" v-if="props.cancelLabel" @click="close">{{ props.cancelLabel }}</button>
              <button class="btn btn-primary" v-if="props.continueLabel" @click="confirm">{{ props.continueLabel }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  const props = defineProps(['title', 'id', 'cancelLabel', 'continueLabel', 'showModal'])
  const emit = defineEmits(['input', 'closed', 'confirm'])

  function confirm() {
      if (props.showModal) {
        emit('input', false)
      }
      emit('confirm')
  }
  function close() {
      if (props.showModal) {
        emit('input', false)
      }
      emit('closed');
  } 
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }
</style>